export const GET_DATA_REQUEST_p = 'GET_DATA_REQUEST_P';
export const GET_DATA_SUCCESS_P = 'GET_DATA_SUCCESS_P';
export const GET_DATA_FAILURE_P = 'GET_DATA_FAILURE_P';
export const GET_DATA_LOADING_P = 'GET_DATA_LOADING_P';

export const ADD_DATA_REQUEST_P = 'ADD_DATA_REQUEST_P';
export const ADD_DATA_SUCCESS_P = 'ADD_DATA_SUCCESS_P';
export const ADD_DATA_FAILURE_P = 'ADD_DATA_FAILURE_P';
export const DELETE_DATA_P = 'delete_data_P';